export enum SelectType {
  Default,
  Multiple,
  Cascade,
}
